import { ReportService } from "./report.service";
import { EntityData } from "../..";
import { DataResourceModel } from "../data.resource.model";
import { SavedReportData } from "./saved-report.data";
/**
 * Provides an report model and its dependencies
 * @param modelType
 * @returns {any[]}
 */
export function provideReportModel(modelType) {
    return [
        modelType,
        { provide: ReportModel, useExisting: modelType },
        { provide: DataResourceModel, useExisting: modelType }
    ];
}
/**
 * Base class for all report models.
 */
export class ReportModel extends DataResourceModel {
    constructor(injector, dataType) {
        super(dataType);
        this.injector = injector;
        if (injector == null) {
            console.error("!!!! Injector not provided. This is most likely due to a missing constructor in " + this.constructor.toString());
        }
        this.reportService = injector.get(ReportService);
        this.createEntity();
    }
    /**
     * Create a new instance of the entity
     */
    createEntity() {
        let entityData = EntityData.create(this.dataType);
        this.data = entityData;
    }
    /**
     * Request the report using the data as the report parameters
     * @returns {Promise<ReportRequestData>}
     */
    requestReport() {
        return new Promise((resolve, reject) => {
            let request = this.reportService.requestReport(this.getResourceName(), this.data);
            request.then(reportRequest => {
                resolve(reportRequest);
            }).catch((error) => {
                if (error.validationFailure) {
                    resolve(error.data);
                }
                else {
                    reject(error);
                }
            });
        });
    }
    getDefaultSavedReportParameters() {
        return new Promise((resolve, reject) => {
            this.reportService.getDefaultSavedReportParameters(this.getResourceName(), this.getCustomReportName()).then(defaultReport => {
                if (defaultReport) {
                    const reportDefault = EntityData.create(SavedReportData);
                    reportDefault.assign(defaultReport);
                    resolve(reportDefault);
                }
                else {
                    resolve(null);
                }
            }).catch((error) => {
                reject(error);
            });
        });
    }
    /**
     * Overridden by models that deal with custom reports
     */
    getCustomReportName() {
        return undefined;
    }
    getSavedReportParameters(identifier) {
        return new Promise((resolve, reject) => {
            this.reportService.getSavedReportParameters(this.getResourceName(), identifier).then(defaultReport => {
                if (defaultReport) {
                    const reportDefault = EntityData.create(SavedReportData);
                    reportDefault.assign(defaultReport);
                    resolve(reportDefault);
                }
                else {
                    resolve(null);
                }
            }).catch((error) => {
                reject(error);
            });
        });
    }
    getResource() {
        return this.getResourceName();
    }
}
//# sourceMappingURL=report.model.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fedelta-pos/data-client/resource/report/report.model.js
// module id = null
// module chunks = 